module.exports = __webpack_public_path__ + "static/media/marketplace.0390d4d7.svg";